{
  "Authentication_LoginButton": "Sign In",
  "LoginForm_LoginTitle": "Log in to your account",
  "LoginForm_WelcomeBack": "Welcome back! Please enter your details.",
  "LoginForm_Username": "Username",
  "LoginForm_UsernameRequired": "Username is required",
  "LoginForm_InvalidEmail": "Username must be an email",
  "LoginForm_UsernamePlaceholder": "Enter your username",
  "LoginForm_Password": "Password",
  "LoginForm_CME": "CME",
  "LoginForm_Or": "(Or)",
  "LoginForm_Server": "Server",
  "LoginForm_LoginLanding_UserOnMultipleServices": "That username exists on multiple services. Please provide additional information in order to identify your user.",
  "LoginForm_LoginLanding_UserNonAdmin_Error": "There is a problem logging into your account. Please contact your administrator to rectify the issue.",
  "LoginForm_LoginLanding_User_Not_Found_Error": "We couldn't find the username you entered. Please double-check and try again.",
  "LoginForm_ServerPlaceholder": "Please select server to sign-in to",
  "LoginForm_PasswordRequired": "Password is required",
  "LoginForm_PasswordPlaceholder": "••••••••",
  "LoginForm_RememberMe": "Remember me",
  "LoginForm_ForgotPassword": "Forgot password",
  "LoginForm_SignIn": "Sign In",
  "LoginForm_LandingPage_NextButton": "Continue",
  "Authentication_ChangeBrowserProfile": "Change Browser Profile",
  "NAME": "Authentication"
}